import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { FacilitatorOverviewModel } from '../../GET_NEW_UI/setup-induction-question/setup-induction-question';
import { CustomerIdAndNameDataSet, CustomerUserContacts, EqLevelData, Jobsite_tab, UserInfoVMJS, UserOverviewModelCustomerContact } from '../Models/customer-contact.model';
import { CustomerTab } from '../Models/customer-details.model';

@Injectable()
export class CustomerContactService {
  

  private readonly API_USER_BASE = 'http://localhost:49468/api/User/';
  private readonly API_BASE = 'http://localhost:49468/api/AddJobtoCustomer/';
  private readonly API_BASE2 = 'http://localhost:49468/api/AddEquipemt/';
  private readonly API_BASE3 = 'http://localhost:49468/api/ContactToJS/';
  private readonly API_BASE4 = 'http://localhost:49468/api/AddUSERJOBSite/';//

  //eqlevel post list view
  private readonly POST_EL_DATA = this.API_BASE2 + 'PostELData';

  private readonly GET_USER_INFO = this.API_USER_BASE + 'getUserInfo';
  private readonly POST_USER_CONTACT = this.API_USER_BASE +'AddNewUser';
  private readonly UPDATE_USER_CONTACT = this.API_USER_BASE + 'AddUserInJS';
  private readonly GET_CONTCT_TOID=this.API_USER_BASE+'getContact';//AddContactsfromJS

  private readonly GET_EQID=this.API_BASE2+'GetEquipmentbyId';

  private readonly GET_JS=this.API_USER_BASE+'GetJobsitebyId';
  private readonly POST_USERTOJOBSITE_INFO = this.API_USER_BASE + 'addUsertoJSL';

  private readonly GET_CONTOCL_INFO = this.API_USER_BASE + 'getContactToCL';
 
  private readonly ADD_EJOB_INFO = this.API_BASE4 + 'AddNewUsertoJobsite';
  private readonly POST_JOB_USER = this.API_USER_BASE + 'postJobUser';
  private readonly POST_CONTACT_FROM = this.API_BASE3 + 'AddContactsfromJS';//ContactToJS

  //Post contct details AddContactsfromJS
  public AddContactsfromJS(info:CustomerUserContacts){
    
    return this._http.post(this.POST_CONTACT_FROM,info).pipe(catchError(this.handleError));
  }
  

  constructor(private _http: HttpClient, ) { }


  public GetuserDetails() {
    return this._http.get(this.GET_USER_INFO).pipe(catchError(this.handleError));
  }
  
  public GetCLDetails() {
    return this._http.get(this.GET_USER_INFO).pipe(catchError(this.handleError));
  }
  public AddNewUser(info:CustomerUserContacts){
    
    return this._http.post(this.POST_USER_CONTACT,info).pipe(catchError(this.handleError));
  }
  public postJobUser(info:CustomerTab){
    
    return this._http.post(this.POST_JOB_USER,info).pipe(catchError(this.handleError));
  }


  public GetContactbyId(cusId:number)
  {
    const options = {
      params: new HttpParams().set('cusId', cusId.toString())

    };
    return this._http.get(this.GET_CONTCT_TOID, options).pipe(catchError(this.handleError));

    //return this._http.get(this.GET_CONTCT_TOID,selectedUserId).pipe(catchError(this.handleError));

  }

  public GetEquipmentbyId(customerID:number)
  {
    const options = {
      params: new HttpParams().set('customerID', customerID.toString())

    };
    return this._http.get(this.GET_EQID, options).pipe(catchError(this.handleError));

    //return this._http.get(this.GET_CONTCT_TOID,selectedUserId).pipe(catchError(this.handleError));

  }

  public GetJobsitebyId(customerID:number)
  {
    const options = {
      params: new HttpParams().set('customerID', customerID.toString())

    };
    return this._http.get(this.GET_JS, options).pipe(catchError(this.handleError));

    //return this._http.get(this.GET_CONTCT_TOID,selectedUserId).pipe(catchError(this.handleError));

  }
  
  public AddUserInJS(user_auto:number,job_site:string){
    const options = {
      params: new HttpParams().set('user_auto', user_auto.toString()).set('customer_auto', job_site)

    };
    return this._http.get(this.POST_USERTOJOBSITE_INFO, options).pipe(catchError(this.handleError));
  }
 
  
  public AddNewUsertoJobsite(info:Jobsite_tab)
  {
    return this._http.post(this.ADD_EJOB_INFO,info).pipe(catchError(this.handleError));
  }
  public PostELData(info:EqLevelData){
    
    return this._http.post(this.POST_EL_DATA,info).pipe(catchError(this.handleError));
  }
 /* private handleError(err: HttpErrorResponse): Observable<any> {
    console.log('handled error ' + err.status);
    return  Observable.throw(err || 'Server error');
    ///
    public changeMeterUnit(changeUnitModel: ChangeMeterUnitModel): Observable<Tuple> {
    return this._http.post(this.CHANGE_EQUIPMENT_METER_UNIT, changeUnitModel).pipe(catchError(this.handleError));
  }

  }*/

  
  public getContactToCL(userNo:number)
  {
    const options = {
      params: new HttpParams().set('userNo', userNo.toString())

    };
    return this._http.get(this.GET_CONTOCL_INFO, options).pipe(catchError(this.handleError));

    //return this._http.get(this.GET_CONTCT_TOID,selectedUserId).pipe(catchError(this.handleError));

  }

  // private handleError(error: HttpErrorResponse) {
  //   if (error.error instanceof ErrorEvent) {
  //     // A client-side or network error occurred. Handle it accordingly.
  //     console.error('An error occurred:', error.error.message);
  //   } else {
  //     // The backend returned an unsuccessful response code.
  //     // The response body may contain clues as to what went wrong.
  //     console.error(
  //       `Backend returned code ${error.status}, ` +
  //       `body was: ${error.error}`);
  //   }
  //   // Return an observable with a user-facing error message.
  //   return throwError(
  //     'Something bad happened; please try again later.');
  // }

  private handleError(error: Response) {
    return Observable.throw(error || 'Server error');
  }


  public GetCustomerDetails(): Observable<CustomerIdAndNameDataSet[]> {
    return this._http.get<CustomerIdAndNameDataSet[]>('api/Customer/getListOfCustomersForLoggedInUser').pipe(catchError(this.handleError));
  }
  
  public GetuserDetails_(): Observable<UserInfoVMJS[]> {
    return this._http.get<UserInfoVMJS[]>('api/User/getUserInfo').pipe(catchError(this.handleError));
  }


  
  public GetAllUsersForUser(): Observable<UserOverviewModelCustomerContact[]> {
    return this._http.get<UserOverviewModelCustomerContact[]>('api/PerfomeInduction/GetAllUsersForUserforCusContact').pipe(catchError(this.handleError));
  }

  // public GetAllUsersForSelectedJobSite(): Observable<UserOverviewModelCustomerContact[]> {
  //   return this._http.get('api/PerfomeInduction/GetAllUsersForUserforCusContact').pipe(catchError(this.handleError));
  // }
  public GetAllUsersForSelectedJobSite(JobsiteId: number): Observable<UserOverviewModelCustomerContact[]> {
    const options = {
      params: new HttpParams().set('JobsiteId', JobsiteId.toString())
    };
    return this._http.get<UserOverviewModelCustomerContact[]>('api/PerfomeInduction/GetAllUsersForUserforCusContact', options).pipe(catchError(this.handleError));
  }

 //customer contact users

 public GetAllFacilitatorsForUser(): Observable<FacilitatorOverviewModel[]> {
  return this._http.get<FacilitatorOverviewModel[]>('api/PerfomeInduction/GetAllFacilitatorsForUser').pipe(catchError(this.handleError));
}


//TT-5067
public getUserInfoforUserContact(): Observable<UserInfoVMJS[]> {
  return this._http.get<UserInfoVMJS[]>('api/User/getUserInfoforUserContact').pipe(catchError(this.handleError));
}


  
}
